import { ENTRYPOINTS } from 'ai/constants/superchat';

function findPreviousSession(conversationResponse, entryPointData) {
    if (!conversationResponse || !entryPointData) {
        return null;
    }

    const lastMessage = conversationResponse.messages?.at();
    const lastSession = conversationResponse.sessions?.find(s => s.session_id === lastMessage?.session_id);
    const lastUsedSession = conversationResponse.sessions?.find(s => s.session_id === entryPointData?.sessionId);

    if (entryPointData?.sessionId) {
        if (lastUsedSession && !lastUsedSession?.expired) {
            return entryPointData?.sessionId;
        }

        return null;
    }

    if (lastSession && lastSession.expired) {
        // New session needed
        return null;
    }

    if (lastSession?.entrypoint === ENTRYPOINTS.PDP) {
        if (lastSession.products?.[0]?.id === entryPointData.products?.[0]?.product_id) {
            return lastSession.session_id;
        }
    } else if (lastSession?.entrypoint === ENTRYPOINTS.PLP) {
        if (lastSession.category_id === entryPointData.category_id) {
            return lastSession.session_id;
        }
    } else if (lastSession?.entrypoint === ENTRYPOINTS.SRP) {
        if (lastSession.search_term === entryPointData.search_term) {
            return lastSession.session_id;
        }
    } else if (lastSession?.entrypoint === ENTRYPOINTS.DEFAULT) {
        if (entryPointData.entrypoint === ENTRYPOINTS.DEFAULT) {
            return lastSession.session_id;
        }
    }

    return null;
}

export default findPreviousSession;
